import { render, staticRenderFns } from "./left-second.vue?vue&type=template&id=85dee858&scoped=true&"
import script from "./left-second.vue?vue&type=script&lang=js&"
export * from "./left-second.vue?vue&type=script&lang=js&"
import style0 from "./left-second.vue?vue&type=style&index=0&id=85dee858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dee858",
  null
  
)

export default component.exports